
<div :class="focusedOnboardingFlow ? '' : 'form__group--border py-16 pb-32'">
  <p class="form__label">Set your base hourly rate <span v-if="childCare">for 1 child</span></p>
  <p class="text-caption">You can update your rate at anytime</p>
  <PaymentRateNoteBox :childCare="childCare" :payRateFetchError="payRateFetchError" :payRange="payRange" />
  <fieldset>
    <legend class="sr-only">Set your base hourly rate <span v-if="childCare">for 1 child</span></legend>
    <div class="inline-flex">
      <poppins-text-field
        id="min"
        ref="minimumRate"
        v-model="min"
        labelName="$ Min"
        :aria-label="'Set your minimum rate'"
        name="minimum-rate"
        type="text"
        pattern="[0-9]*"
        inputmode="numeric"
        :status="formStatuses.min"
        :required="true"
        :limit-input-to-pattern="true"
        @blur="validateMinimumRate"
      />
      <p class="p-16">to</p>
      <poppins-text-field
        id="max"
        ref="maximumRate"
        v-model="max"
        labelName="$ Max"
        :aria-label="'Set your maximum rate'"
        name="maximum-rate"
        type="text"
        pattern="[0-9]*"
        inputmode="numeric"
        :status="formStatuses.max"
        :required="true"
        :limit-input-to-pattern="true"
        @blur="validateMaximumRate"
      />
    </div>
    <div v-if="hasErrors" class="mt-4" data-test-id="errors">
      <div v-for="key in formStatusesErrors" :key="key" class="flex relative">
        <HelperText :id="key" :text="helperText(0, key)" :status="0" />
      </div>
    </div>
  </fieldset>
  <div class="mt-20">
    <HelperText v-if="childCare" :text="helperTextMessage" />
    <HelperText v-else text="Average rates vary based on location and experience" />
  </div>
</div>
